(() => {
  const drawer = document.querySelector("[data-mobile-drawer]");
  const overlay = document.querySelector("[data-drawer-overlay]");
  const toggles = document.querySelectorAll("[data-drawer-toggle]");

  const setDrawer = (open) => {
    if (!drawer || !overlay) return;
    drawer.classList.toggle("is-open", open);
    overlay.classList.toggle("is-open", open);
    document.body.style.overflow = open ? "hidden" : "";
  };

  toggles.forEach((toggle) => {
    toggle.addEventListener("click", () => setDrawer(!drawer.classList.contains("is-open")));
  });

  overlay?.addEventListener("click", () => setDrawer(false));

  document.addEventListener("keyup", (event) => {
    if (event.key === "Escape") setDrawer(false);
  });
})();

(() => {
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const editorMode = Boolean(window.Shopify?.designMode);
  let revealObserver;

  const revealNow = (element) => {
    element.classList.add("is-visible");
  };

  const prepareSections = (root = document) => {
    root.querySelectorAll("#MainContent .shopify-section > section, #MainContent > section, #MainContent section").forEach((section) => {
      section.classList.add("scroll-reveal");
    });
  };

  const prepareProductCards = (root = document) => {
    const cards = root.querySelectorAll(".product-card");

    cards.forEach((card, index) => {
      card.classList.add("scroll-reveal__item", "scroll-reveal--product");
      card.style.setProperty("--reveal-delay", `${Math.min(index, 8) * 70}ms`);
    });
  };

  const observeRevealElements = (root = document) => {
    const elements = root.querySelectorAll(".scroll-reveal, .scroll-reveal__item");

    elements.forEach((element) => {
      if (element.dataset.revealBound === "true") return;
      element.dataset.revealBound = "true";

      if (reduceMotion || editorMode || !revealObserver) {
        revealNow(element);
        return;
      }

      revealObserver.observe(element);
    });
  };

  const refreshReveals = (root = document) => {
    prepareSections(root);
    prepareProductCards(root);
    observeRevealElements(root);
  };

  if (!reduceMotion && !editorMode && "IntersectionObserver" in window) {
    document.documentElement.classList.add("js-reveal-ready");

    revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          revealNow(entry.target);
          revealObserver.unobserve(entry.target);
        });
      },
      {
        rootMargin: "0px 0px -12% 0px",
        threshold: 0.16
      }
    );
  }

  refreshReveals();

  document.addEventListener("shopify:section:load", (event) => {
    refreshReveals(event.target);
  });

  document.addEventListener("shopify:section:reorder", () => {
    refreshReveals();
  });
})();
